<template>
  <v-card class="d-flex flex-column align-center img" flat tile>
    <img
      class="d-block mx-auto item-img"
      :src="files + img + '?resize=1&w=60'"
      height="60px"
      width="60px"
      :alt="title"
    />

    <div
      class="accent--text text-h6 text-md-h5 text-center font-weight-bold mt-4"
    >
      {{ title }}
    </div>

    <div
      v-if="text"
      class="
        grey--text
        text-body-1 text-center
        font-weight-regular
        mt-4
        item-text
      "
    >
      <span class="font-secondary" v-html="text"></span>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    object-fit: contain;
  }
}

.item-text::v-deep {
  li {
    text-align: left;
  }
}
</style>
